<template>
  <div class="page-navigation">
    <router-link :to="pagePrecedente" v-if="showLeftArrow">
      <div class="arrow left">
        <img class="image-arrow-left" src="../assets/arrow_forward_ios_FILL0_wght400_GRAD0_opsz24.svg"/>
      </div>
    </router-link>
    <div class="title">
      {{ pageTitle }}
    </div>
    <router-link :to="pageSuivante" v-if="showRightArrow">
      <div class="arrow right">
        <img class="image-arrow-right" src="../assets/arrow_forward_ios_FILL0_wght400_GRAD0_opsz24.svg"/>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: String, // Propriété pour le titre de la page
    pagePrecedente: String,
    pageSuivante: String,
    showLeftArrow: {
      type: Boolean,
      default: true,
    },
    showRightArrow: {
      type: Boolean,
      default: true,
    },
  }
};
</script>

<style scoped>
.page-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.title {
  font-weight: bold;
  font-size: 1.3rem;
  text-align: center;
}

.arrow {
  cursor: pointer;
  font-size: 24px;
}

.image-arrow-left {
  rotate: 180deg;
}

.title.ios{
  margin-top:30px;
}
</style>
